import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  changeDefaultQueryParams,
  changeQueryParams,
  changeStaticQueryParams,
  selectItemById,
  selectItemsIds,
  selectRequestState,
  selectPagination,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';

import {
  selectUserId,
  selectAvatarPath
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';

const listReduceName = 'messengerModule.lists.messengerMyRoomsList';

export default function createContainer(ChildContainer) {
  class UserRoomsListContainer extends Component {
    constructor(props) {
      super(props);
      this.handleSendRequest();
    }

    handleSendRequest() {
      this.props.sendRequest();
    }

    render() {
      return <ChildContainer {...this.props} />;
    }
  }
  UserRoomsListContainer.propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        tag: PropTypes.string
      }).isRequired
    }).isRequired,

    auntUserId: PropTypes.number.isRequired,
    auntUserAvatarPath: PropTypes.string.isRequired,

    // CONNECT DISPATCH
    sendRequest: PropTypes.func.isRequired,
    changeStaticQueryParams: PropTypes.func.isRequired
  };

  const mapStateToProps = state => ({
    auntUserId: selectUserId(state),
    auntUserAvatarPath: selectAvatarPath(state),

    requestState: selectRequestState(state, listReduceName),
    itemsIds: selectItemsIds(state, listReduceName),
    pagination: selectPagination(state, listReduceName),
    selectItemById: id => selectItemById(state, listReduceName, id)
  });

  const mapDispatchToProps = dispatch => ({
    changeStaticQueryParams: queryParams =>
      dispatch(changeStaticQueryParams(listReduceName, queryParams)),
    changeDefaultQueryParams: queryParams =>
      dispatch(changeDefaultQueryParams(listReduceName, queryParams)),
    changeQueryParams: queryParams =>
      dispatch(changeQueryParams(listReduceName, queryParams)),
    sendRequest: () => dispatch(sendRequest(listReduceName))
  });
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserRoomsListContainer);
}



// WEBPACK FOOTER //
// ./src/components/Messenger/containers/UserRoomsListContainer/UserRoomsListContainer.js